import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Pure1NavigationService } from '@pure/pure1-ui-platform-angular';
import { firstValueFrom } from 'rxjs';
import { WINDOW } from '../../app/injection-tokens';
import { SupportCase } from '../support.interface';

@Injectable({
    providedIn: 'root',
})
export class SupportCenterRedirectService {
    constructor(
        private navigationService: Pure1NavigationService,
        @Inject(WINDOW) private window: Window,
    ) {}

    async openSupportCenter(caseId?: string): Promise<void> {
        const path = caseId ? `cases/${caseId}` : undefined;
        const link = await firstValueFrom(this.navigationService.link('support-center', path));
        this.window.open(link, '_blank');
    }

    async openCreateCase(supportCase?: Partial<SupportCase>, searchArray?: string): Promise<void> {
        let params = new HttpParams();
        if (supportCase) {
            if (supportCase.category) {
                params = params.append('category', supportCase.category);
            }
            if (supportCase.subCategory) {
                params = params.append('subCategory', supportCase.subCategory);
            }
            if (supportCase.severity) {
                params = params.append('severity', supportCase.severity);
            }
            if (supportCase.subject) {
                params = params.append('subject', supportCase.subject);
            }
            if (supportCase.description) {
                params = params.append('description', supportCase.description);
            }
            if (supportCase.productLine) {
                params = params.append('productLine', supportCase.productLine);
            }
        }
        if (searchArray) {
            params = params.append('searchArray', searchArray);
        }
        const link = await firstValueFrom(
            this.navigationService.link('support-center', `createCase?${params.toString()}`),
        );
        this.window.open(link, '_blank');
    }
}
